import * as React from "react";
import Header from "./components/Header";
import {Body, Section} from "@athena-portal/components";

export class Layout extends React.Component {
    public render() {
        return (
            <>
                <div>
                    <Header/>
                    <div className="container-fluid">
                        <div className="container pt-3 pb-3">
                            <Body/>
                        </div>
                    </div>
                </div>
                <footer className="footer-position">
                    <Section id="footer"/>
                </footer>
            </>
        );
    }
}
